angular.module('impactx.lot').controller('LotListForTenderCtrl', ['$routeParams', '$controller', LotListForTenderCtrl]);

function LotListForTenderCtrl($routeParams, $controller)
{
    var mainCtrl = $controller('LotListCtrl', {});

    this.meta = {
        rowTemplate: 'modules/lot/templates/lotlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/lot/listfortender',
        id: "lotlistfortender",
        mainAction : {id:"new", link: "#/lotdetail/0", icon:"mdi-plus"},
        params: {'tenderId': $routeParams.tenderId ? $routeParams.tenderId : 0},
        excelParams: {
            params: [{param: 'TenderId', intValue: $routeParams.tenderId ? $routeParams.tenderId : 0}]
        },
        buttonDefinition: mainCtrl.buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}